import api from '@/lib/api';
import { DashboardResponse, DashboardMetricsRequest } from '@/types/api';

export const dashboardService = {
  // Obter métricas do dashboard
  async getDashboardMetrics(params: DashboardMetricsRequest): Promise<DashboardResponse> {
    const queryParams = new URLSearchParams({
      period: params.period,
      compareWithPrevious: params.compareWithPrevious.toString(),
    });

    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }

    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }

    const response = await api.get<DashboardResponse>(`/dashboard?${queryParams.toString()}`);
    return response.data;
  },
};
